var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 20.8978V18.7641H6.25008V11.2961C6.25008 9.82027 6.68411 8.51337 7.55216 7.37539C8.42022 6.21962 9.54869 5.46393 10.9376 5.10831V4.36152C10.9376 3.91699 11.0852 3.54359 11.3803 3.24131C11.6928 2.92126 12.0661 2.76123 12.5001 2.76123C12.9341 2.76123 13.2987 2.92126 13.5938 3.24131C13.9063 3.54359 14.0626 3.91699 14.0626 4.36152V5.10831C15.4515 5.46393 16.5799 6.21962 17.448 7.37539C18.3161 8.51337 18.7501 9.82027 18.7501 11.2961V18.7641H20.8334V20.8978H4.16675ZM12.5001 24.0984C11.9272 24.0984 11.4324 23.8939 11.0157 23.4849C10.6164 23.0582 10.4167 22.5514 10.4167 21.9647H14.5834C14.5834 22.5514 14.3751 23.0582 13.9584 23.4849C13.5591 23.8939 13.073 24.0984 12.5001 24.0984ZM8.33342 18.7641H16.6667V11.2961C16.6667 10.1225 16.2588 9.11792 15.4428 8.28221C14.6268 7.44651 13.6459 7.02866 12.5001 7.02866C11.3542 7.02866 10.3733 7.44651 9.55737 8.28221C8.7414 9.11792 8.33342 10.1225 8.33342 11.2961V18.7641Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.5649119ade1f01bf2eebe3db8802f2a3.svg";
export { ForwardRef as ReactComponent };